import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import MachineForm from '@galo-monitor/web-containers/forms/farm/MachineForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const MachineModal = (props) => {
  const {
    id,
    open,
    handleClose,
    onSuccess,
    machine
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    err => {
      setLoading(false)

      const { errors } = err.response.data
      const errorMessages = map(errors, error => (
        <React.Fragment key={ error.field }>
          {`${ t('error') }: ${ t('minLength validation failed') }.`}
          <br />
          {
            t('validation error message', {
              field: error.field,
              rule: error.rule
            })
          }.
          <br />
        </React.Fragment>
      ))

      createDialog({
        id: 'error-machine',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t(isEmpty(machine) ? 'register' : 'update')),
            this: toLower(t('machine', { howMany: 1 }))
          })  }.`,
          message: errorMessages
        }
      })
    },
    [createDialog, machine, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', {
        this: t('machine', { howMany: 1 })
      }) }
      maxWidth="md"
      fullWidth
      contentContainerStyle={ {
        minHeight: '40vh',
        paddingTop: 15,
        overflowY: 'hidden'
      } }
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <MachineForm
        ref={ formRef }
        machine={ machine }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

MachineModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  machine: PropTypes.object
}

MachineModal.defaultProps = {
  machine: {}
}

export default MachineModal
